/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/10/2022
 */


import WheelItem from "@shared/WheelModel/WheelItem";
import {Type, classToClass, classToPlain, plainToClass} from "@qwoach/class-transformer-wrapper";
import WheelSingleResponse from "@shared/WheelModel/WheelSingleResponse";
import {dateLabelFormatted} from "@/utils/helpers";
import dayjs from "dayjs"
import {FilterableProperty, SyncProperty} from "@shared/Filterable/PropertyDecorators";
import TagItem from "@shared/Tags/TagItem";

export default class WheelAnswerItem extends WheelItem{


	parentWheelId: string = null

	coachId: string = null
	teamMemberId: string = null
	coachName: string = null
	clientId: string = null

	@FilterableProperty()
	clientName: string = null

	@FilterableProperty()
	clientEmail: string = null

	@FilterableProperty({indexPropName: "company_index"})
	company: string = null

	phone: string = null
	address: string = null


	@SyncProperty({targetProp: "company", transform: item => item.toLowerCase()})
	company_casefolded: string = null


	@Type(() => WheelSingleResponse)
	responses: WheelSingleResponse[] = []

	nextReminderId: string = null
	nextReminderTs: number = null

	@FilterableProperty({transform: tag => tag.title, indexPropName: "tags_index"})
	@Type(() => TagItem)
	tags: TagItem[] = []

	lastExportedTs: number = Number.MAX_SAFE_INTEGER //we store max int instead of 0 so we can do filtering by last exported
	isExported: boolean = false


	constructor() {
		super();
	}

	static createFrom(wheelItem){
		wheelItem = plainToClass(WheelAnswerItem, classToPlain(wheelItem))
		wheelItem.parentWheelId = wheelItem.id
		wheelItem.resetObject()
		wheelItem.saveAnswers()
		if(wheelItem.autoTagsData.isEnabled){
			wheelItem.tags = wheelItem.autoTagsData.tags
		}
		return wheelItem
	}

	setCoachProfile(coachProfile){
		this.coachId = coachProfile.id
		this.coachName = coachProfile.name
	}

	setClientProfile(clientProfile){
		this.clientId = clientProfile.id
		this.clientName = clientProfile.name
		this.clientEmail = clientProfile.email
		this.company = clientProfile.company
		this.phone = clientProfile.phone
		this.address = clientProfile.primaryAddress?.toString() || null
	}

	saveAnswers(){
		let answers = this.getAnswers()
		let response = new WheelSingleResponse(classToClass(answers))
		this.responses.push(response)
		this.resetAnswers()
	}


	loadAnswers(index){
		let wheelSingleResponse = this.getResponses(index)
		let segments = classToClass(wheelSingleResponse.segments)
		this.segmentArray = segments
	}

	getLastResponse(){
		return this.getResponses()
	}
	getResponses(index){
		if(index === undefined){
			index = this.responses.length - 1
		}
		return this.responses[index]
	}

	lastCompletedFormatted(){
		let responses = this.getLastResponse()
		return dateLabelFormatted("Last completed: ", responses.createdAt)
	}

	nextReminderFormatted(){
		return dayjs(this.nextReminderTs).format("dddd, MMM DD, YYYY")
	}
	getHash(){
		return this.parentWheelId + "_" + this.segmentArray.map(segment => segment.label).join("_")
	}

	setExportedNow(){
		this.lastExportedTs = Date.now()
		this.isExported = true
	}


}



